import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('jobsV2');

export default resourceActions;
